module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/162-germany-00b725458716d306074882c745f5eb25.svg";